<template>
  <div>
    <portal target-el="#filtertron-tray">
      <filtertron-tray
        :heading="heading"
        :is-open="trayOpen"
        @beforeClose="onBeforeClose"
      >
        <template scope="{ scrollToTop }">
          <field-configurator
            v-if="field"
            :key="'field-configurator-' + field.slug"
            :field="field"
            @created="scrollToTop"
          />
          <tab-configurator
            v-if="tab"
            :key="'tab-configurator-' + tab.slug"
            :tab="tab"
            @created="scrollToTop"
          />
          <category-configurator
            v-if="category"
            :key="'category-configurator-' + category.slug"
            :category="category"
            @created="scrollToTop"
          />
          <message
            v-if="chapter && !chapter.createdAt && isAtChapterLimit"
            :title="lang.get('chapters.messages.limit.title')"
            :message="lang.get('chapters.messages.limit.message')"
          />
          <chapter-configurator
            v-else-if="chapter"
            :key="'chapter-configurator-' + chapter.slug"
            :chapter="chapter"
            @created="scrollToTop"
          />
        </template>
      </filtertron-tray>
    </portal>
    <confirmation-modal
      modal-id="modal-target-close-configuration-tray"
      :show-modal="confirmClose"
      :confirmation="lang.get('miscellaneous.unsaved_changes')"
      :confirm-button-label="lang.get('buttons.continue')"
      :cancel-button-label="lang.get('buttons.cancel')"
      @closed="confirmClose = false"
      @confirmed="close"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { truncate } from '@/lib/utils.js';
import ConfirmationModal from '@/lib/components/Shared/ConfirmationModal';
import FiltertronTray from '@/lib/components/Filtertron/FiltertronTray';
import FieldConfigurator from './FieldConfigurator/FieldConfigurator';
import TabConfigurator from './TabConfigurator/TabConfigurator';
import CategoryConfigurator from './CategoryConfigurator/CategoryConfigurator';
import ChapterConfigurator from './ChapterConfigurator/ChapterConfigurator';
import Message from './Message';

export default {
  inject: ['lang', 'currencies'],
  components: {
    ConfirmationModal,
    FiltertronTray,
    FieldConfigurator,
    TabConfigurator,
    CategoryConfigurator,
    ChapterConfigurator,
    Message
  },
  data() {
    return {
      confirmClose: false
    };
  },
  computed: {
    ...mapState('entryForm', [
      'fields',
      'tabs',
      'chapters',
      'isAtChapterLimit'
    ]),
    ...mapState('entryFormConfiguration', [
      'configuredField',
      'configuredTab',
      'configuredCategory',
      'configuredChapter',
      'configurationInProgress'
    ]),
    ...mapGetters('entryForm', ['categoriesIndex']),
    trayOpen() {
      return (
        this.field !== undefined ||
        this.tab !== undefined ||
        this.category !== undefined ||
        this.chapter !== undefined
      );
    },
    field() {
      return this.fields.find(f => f.slug === this.configuredField);
    },
    tab() {
      return this.tabs.find(t => t.slug === this.configuredTab);
    },
    category() {
      return this.categoriesIndex.find(c => c.slug === this.configuredCategory);
    },
    chapter() {
      return this.chapters.find(c => c.slug === this.configuredChapter);
    },
    heading() {
      if (this.field) {
        return truncate(this.field.title, 25);
      } else if (this.tab) {
        return truncate(this.tab.name, 25);
      } else if (this.category) {
        return truncate(this.category.name, 25);
      } else if (this.chapter) {
        return truncate(this.chapter.name, 25);
      } else {
        return '';
      }
    }
  },
  methods: {
    ...mapActions('entryFormConfiguration', ['restoreConfiguration']),
    ...mapMutations('entryFormConfiguration', [
      'setConfigurationInProgressFlag'
    ]),
    onBeforeClose() {
      if (this.configurationInProgress) {
        this.confirmClose = true;
      } else {
        this.close();
      }
    },
    close() {
      this.restoreConfiguration().then(() => {
        this.setConfigurationInProgressFlag(false);
      });
    }
  }
};
</script>
